// extracted by mini-css-extract-plugin
export default {"card":"styles_card__e4rse","card__label":"styles_card__label__IkhVW","card__name":"styles_card__name__uNNK3","card__contact-methods":"styles_card__contact-methods__a2BIC"};